import { Grid } from '@material-ui/core';
import { MeetingRoom } from '@material-ui/icons';
import { Add } from '@material-ui/icons';
import _ from 'lodash';
import React from 'react';
import { ExamDayViewModel } from '../../model/ExamDayViewModel';
import CustomButton from '../common/buttons/CustomButton';
import RightButtonArea from '../common/buttons/RightButtonArea';
import TitleWithIcon from '../common/TitleWithIcon';
import ExamDayCard from './ExamDayCard';
import TranslatedMessage from '../translations/TranslatedMessage';

interface ExamDayListProps {
  examDays?: ExamDayViewModel[];
  onExamDaySelected?: (examDayId: string) => void;
  onStartAddingExamDay?: () => void;
  isReadOnly: boolean;
  showAddButton?: boolean;
}

const ExamDayList: React.FunctionComponent<ExamDayListProps> = ({ examDays, isReadOnly, showAddButton, ...eventHandlers }) => {

  const sortedExamDays = _.orderBy(examDays, (examDay) => examDay.date);
  const examDayCards = sortedExamDays.map(examDay =>
    <Grid item={true} xs={12} sm={6} md={4} lg={3} xl={2} key={examDay.id}>
      <ExamDayCard
        examDay={examDay}
        onClick={eventHandlers.onExamDaySelected}
      />
    </Grid>
  );

  return (
    <React.Fragment>
      <Grid container={true} spacing={0} alignItems="baseline">
        <Grid item={true} xs={12} sm={6}>
          <TitleWithIcon title={<TranslatedMessage id="examDay.field.header" />} variant='h5' >
            <MeetingRoom fontSize='small' />
          </TitleWithIcon>
        </Grid>
        {!isReadOnly && showAddButton && <Grid item={true} xs={12} sm={6}>
          <RightButtonArea>

            <CustomButton tooltip={<TranslatedMessage id="examDay.button.new" />} onClick={eventHandlers.onStartAddingExamDay!}>
              <Add />
            </CustomButton>
          </RightButtonArea>
        </Grid>}
      </Grid>
      <Grid container={true} spacing={2}>
        {examDayCards}
      </Grid>
    </React.Fragment>
  );
};

ExamDayList.defaultProps = {
  onStartAddingExamDay: () => { },
  showAddButton: true
} as Partial<ExamDayListProps>;

export default ExamDayList;
